export default {
	oemDataModal_celsius: "{value} °C",
	oemDataModal_cerebrumx_diagnostics_coolantTemperature: "Coolant Temperature",
	oemDataModal_cerebrumx_diagnostics_engine: "Engine",
	oemDataModal_cerebrumx_diagnostics_engineHours: "Engine Hours",
	oemDataModal_cerebrumx_diagnostics_engineSpeed: "Engine Speed",
	oemDataModal_cerebrumx_diagnostics_ignitionStatus: "Ignition Status (code)",
	oemDataModal_cerebrumx_diagnostics_oilLife: "Oil Life",
	oemDataModal_cerebrumx_diagnostics_noTireData: "No tire pressure data in this event",
	oemDataModal_cerebrumx_diagnostics_placard: "Placard {value}",
	oemDataModal_cerebrumx_diagnostics_tireFL: "Tire Pressure FL",
	oemDataModal_cerebrumx_diagnostics_tireFR: "Tire Pressure FR",
	oemDataModal_cerebrumx_diagnostics_tireRL: "Tire Pressure RL",
	oemDataModal_cerebrumx_diagnostics_tireRR: "Tire Pressure RR",
	oemDataModal_cerebrumx_diagnostics_unit: "psi",
	oemDataModal_cerebrumx_diagnostics_wheels_fl: "FL",
	oemDataModal_cerebrumx_diagnostics_wheels_fr: "FR",
	oemDataModal_cerebrumx_diagnostics_wheels_rl: "RL",
	oemDataModal_cerebrumx_diagnostics_wheels_rr: "RR",
	oemDataModal_cerebrumx_emptyTab: "This payload carries nothing for this tab.",
	oemDataModal_cerebrumx_energy_absEvLevel: "Absolute EV Level",
	oemDataModal_cerebrumx_energy_absFuelLevel: "Fuel in Tank",
	oemDataModal_cerebrumx_energy_battery: "Battery",
	oemDataModal_cerebrumx_energy_batteryVoltage: "Vehicle Battery",
	oemDataModal_cerebrumx_energy_distanceToEmpty: "Range to Empty",
	oemDataModal_cerebrumx_energy_electric: "Electric",
	oemDataModal_cerebrumx_energy_evLevel: "EV Level",
	oemDataModal_cerebrumx_energy_fuel: "Fuel",
	oemDataModal_cerebrumx_energy_fuelLevel: "Fuel Level",
	oemDataModal_cerebrumx_energy_fuelTankCapacity: "Tank Capacity",
	oemDataModal_cerebrumx_energy_instantConsumption: "Instant Consumption",
	oemDataModal_cerebrumx_energy_totalFuelConsumed: "Total Fuel Consumed",
	oemDataModal_cerebrumx_energy_totalFuelEconomy: "Total Fuel Economy",
	oemDataModal_cerebrumx_live_acceleration: "Acceleration",
	oemDataModal_cerebrumx_live_ambientTemperature: "Ambient Temperature",
	oemDataModal_cerebrumx_live_eventType: "Event Type",
	oemDataModal_cerebrumx_live_gear: "Gear",
	oemDataModal_cerebrumx_live_lastReported: "Last Reported",
	oemDataModal_cerebrumx_live_lateralAcceleration: "Lateral Acceleration",
	oemDataModal_cerebrumx_live_moving: "Moving",
	oemDataModal_cerebrumx_live_odometer: "Odometer",
	oemDataModal_cerebrumx_live_speed: "Speed",
	oemDataModal_cerebrumx_live_speedGps: "GPS Speed",
	oemDataModal_cerebrumx_live_tripDistance: "Trip Distance",
	oemDataModal_cerebrumx_location_accelerationShort: "Accel.",
	oemDataModal_cerebrumx_location_altitude: "Altitude",
	oemDataModal_cerebrumx_location_coordinates: "Position",
	oemDataModal_cerebrumx_location_gpsError: "GPS Error",
	oemDataModal_cerebrumx_location_gpsFix: "GPS Fix",
	oemDataModal_cerebrumx_location_gpsInvalid: "Invalid",
	oemDataModal_cerebrumx_location_gpsValid: "Valid",
	oemDataModal_cerebrumx_location_heading: "Heading",
	oemDataModal_cerebrumx_location_lateralShort: "Lateral",
	oemDataModal_cerebrumx_location_samples: "Telemetry samples",
	oemDataModal_cerebrumx_location_showing: "Showing the newest {shown} of {total} samples",
	oemDataModal_cerebrumx_location_speed: "Speed",
	oemDataModal_cerebrumx_location_time: "Time",
	oemDataModal_cerebrumx_name: "CerebrumX",
	oemDataModal_cerebrumx_tabs_diagnostics: "Diagnostics",
	oemDataModal_cerebrumx_tabs_energy: "Energy",
	oemDataModal_cerebrumx_tabs_live: "Live",
	oemDataModal_cerebrumx_tabs_location: "Location",
	oemDataModal_cerebrumx_tabs_vehicle: "Vehicle",
	oemDataModal_cerebrumx_unreadable: "This payload is not in the CerebrumX JSON shape.",
	oemDataModal_cerebrumx_vehicle_make: "Make",
	oemDataModal_cerebrumx_vehicle_message: "Message",
	oemDataModal_cerebrumx_vehicle_messageId: "Message ID",
	oemDataModal_cerebrumx_vehicle_model: "Model",
	oemDataModal_cerebrumx_vehicle_oem: "OEM",
	oemDataModal_cerebrumx_vehicle_sentAt: "Sent At",
	oemDataModal_cerebrumx_vehicle_trim: "Trim",
	oemDataModal_cerebrumx_vehicle_tripId: "Trip ID",
	oemDataModal_cerebrumx_vehicle_vin: "VIN",
	oemDataModal_cerebrumx_vehicle_year: "Year",
	oemDataModal_copied: "Copied",
	oemDataModal_copy: "Copy JSON",
	oemDataModal_degrees: "{value}°",
	oemDataModal_empty: "No raw OEM data was captured for event {eventId}.",
	oemDataModal_error: "The OEM data could not be loaded.",
	oemDataModal_fahrenheit: "{value} °F",
	oemDataModal_feet: "{value} ft",
	oemDataModal_gallons: "{value} gal",
	oemDataModal_hours: "{value} h",
	oemDataModal_km: "{value} km",
	oemDataModal_kph: "{value} km/h",
	oemDataModal_l100km: "{value} L/100 km",
	oemDataModal_liters: "{value} L",
	oemDataModal_loading: "Loading OEM data…",
	oemDataModal_measure: "{value} {unit}",
	oemDataModal_meta_eventId: "Event ID",
	oemDataModal_meta_eventName: "Event",
	oemDataModal_meta_manufacturer: "Manufacturer",
	oemDataModal_meta_unitTime: "Unit time",
	oemDataModal_meters: "{value} m",
	oemDataModal_miles: "{value} mi",
	oemDataModal_mpg: "{value} mpg",
	oemDataModal_mph: "{value} mph",
	oemDataModal_no: "No",
	oemDataModal_noEvent: "This unit has not reported an event yet.",
	oemDataModal_noEventId: "This reading carries no event id, so its raw OEM data cannot be looked up.",
	oemDataModal_notAvailable: "N/A",
	oemDataModal_open: "OEM data",
	oemDataModal_openFor: "View OEM data for {name}",
	oemDataModal_percent: "{value}%",
	oemDataModal_retry: "Try again",
	oemDataModal_tabs_json: "Raw JSON",
	oemDataModal_title: "OEM data",
	oemDataModal_yes: "Yes",
};
